// extracted by mini-css-extract-plugin
module.exports = {"darkModeButton":"darkModeButton-module--darkModeButton--hKkw4"};